module.exports = __webpack_public_path__ + "static/img/pic200-16.0be5054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic200-16.png
// module id = i05f
// module chunks = 45